module.exports = __webpack_public_path__ + "img/Slice 9.e151f995.png";